import React from 'react';
import { Form, Col, Row, Button, Spinner } from 'react-bootstrap';
import axios, { AxiosRequestConfig } from 'axios';
import { Constants } from "../../constants";
import SiteMenu from "../menu";
import GuestSiteMenu from "../guest_menu";
import moment from 'moment';
import '../../App.css';
import 'bootstrap/dist/css/bootstrap.min.css';
import ReactGA from "react-ga4"

class RentalRequestForm extends React.Component {
    constructor(props) {
        super(props);

        let userExists = !(props.location.state == null || props.location.state.user == null);

        this.state = {
            user: userExists ? props.location.state.user : {},
            userExists: userExists,
            input: {
                firstName: userExists ? props.location.state.user.firstname : '',
                lastName: userExists ? props.location.state.user.lastname : '',
                email: userExists ? props.location.state.user.email : '',
                phoneNumber: userExists ? props.location.state.user.phone : '',
                accountNumber: '',
                propertyName: '',
                propertyState: 'DC',
                propertyAddress: '',
                propertyCity: '',
                propertyZip: '',
                rentalDate: '',
                requestDetails: ''
            },
            accounts: [],
            errors: {},
            loading: false
        };

        this.fileControl = React.createRef();
        this.handleFormChange = this.handleFormChange.bind(this);
        this.handleFileChange = this.handleFileChange.bind(this);
        this.handleSubmit = this.handleSubmit.bind(this);
        this.showButton = this.showButton.bind(this);
        this.createSelectItems = this.createSelectItems.bind(this);
    }

    componentDidMount() {
        if (this.state.userExists) {
            axios.get(`${Constants.apiURL}/api/Payment/accounts`, {
                params: {
                    username: this.state.user.username,
                    isWork: true
                }
            }).then(response => {
                if (response.data) {
                    let input = this.state.input;
                    input.accountNumber = response.data[0].accountID;
                    this.setState(() => ({
                        accounts: response.data,
                        input: input
                    }));
                }
            }).catch((response) => {
                // ? Show to user that request is failed
                this.setState({ errors: [response] })
                this.setState({ loading: false });
                console.log('request failed', response)
            });
        }
    }

    createSelectItems() {
        let items = [];
        items = this.state.accounts.map(function (item) {
            return <option value={item.accountID}>{item.accountID} | {item.accountName}</option>;
        });
        return items;
    }


    handleFileChange(event) {
        console.log(event);
    }

    handleFormChange(event) {
        let input = this.state.input;
        let errors = this.state.errors;

        if (event.target.name.indexOf("Zip") != -1) {
            if (!String(event.target.value).match(/(^[0-9-]{0,11}$)/)) {
                return;
            }
        }
        input[event.target.name] = event.target.value;
        if (!!errors[event.target.name]) {
            errors[event.target.name] = null;
        }

        this.setState({
            input,
            errors
        });
    }

    validate() {
        let input = this.state.input;
        let errors = {};
        let isValid = true;
        if (!input["firstName"]) {
            isValid = false;
            errors["firstName"] = "Please enter your first name.";
        }
        if (!input["lastName"]) {
            isValid = false;
            errors["lastName"] = "Please enter your last name.";
        }


        if (!input["phoneNumber"] || !String(input["phoneNumber"])
            .match(/^(\+\d{1,2}\s)?\(?\d{3}\)?[\s.-]?\d{3}[\s.-]?\d{4}$/)) {
            isValid = false;
            errors["phoneNumber"] = "Invalid phone number.";
        }

        if (!input["email"] || !String(input["email"])
            .toLowerCase()
            .match(/^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
            )) {
            isValid = false;
            errors["email"] = "Invalid email address.";
        }

        if (!input["propertyName"]) {
            isValid = false;
            errors["propertyName"] = "Please enter the property name.";
        }

        if (!input["propertyAddress"]) {
            isValid = false;
            errors["propertyAddress"] = "Please enter the street address.";
        }

        if (!input["propertyCity"]) {
            isValid = false;
            errors["propertyCity"] = "Please enter the city.";
        }

        if (!input["propertyState"]) {
            isValid = false;
            errors["propertyState"] = "Invalid state.";
        }

        if (!input["propertyZip"]) {
            isValid = false;
            errors["propertyZip"] = "Invalid zip.";
        }

        if (!input["rentalDate"]) {
            isValid = false;
            errors["rentalDate"] = "Please choose a day.";
        }
        if (!input["requestDetails"]) {
            isValid = false;
            errors["requestDetails"] = "Invalid details.";
        }

        this.setState({
            errors: errors
        });

        console.log(errors);

        return isValid;
    }

    handleSubmit(event) {

        event.preventDefault();
        console.log(this.fileControl);
        if (!this.validate()) {
            alert('Please fill in required fields to proceed.');
            return;
        }

        this.setState({ loading: true });

        let formData = new FormData();
        for (var key in this.state.input) {
            formData.append(key, this.state.input[key]);
        }

        for (var i = 0; i < this.fileControl.current.files.length; i++) {
            formData.append('attachments', this.fileControl.current.files[i]);
        }

        formData.append('username', this.state.user.username);

        axios.post(`${Constants.apiURL}/api/Request/rental`, formData, {
            headers: { 'Content-Type': 'multipart/form-data' }
        }).then(response => {
            console.log(response);
            if (response.data && response.data == true) {
                ReactGA.event({
                    category: 'Request',
                    action: 'Rental',
                    label: 'Rental Request'
                });
                alert('Your rental order request has been received. A member of our team will be in touch soon!');
                this.props.history.push({
                    pathname: '/orders',
                    state: {
                        user: this.state.user
                    }
                });
            }
            else {
                alert('Error processing your request');
            }
            this.setState({ loading: false });
        }).catch((response) => {
            // ? Show to user that request is failed
            this.setState({ errors: [response] })
            this.setState({ loading: false });
            console.log('request failed', response)
        });
    }

    showButton() {
        if (this.state.loading) {
            return <Button style={{ marginLeft: '10px', backgroundColor: '#1F419B' }} variant="primary" type="submit">
                <Spinner
                    as="span"
                    animation="border"
                    size="sm"
                    role="status"
                    aria-hidden="true" />
                <span className="visually-hidden">Loading...</span>
            </Button>
        }
        else {
            return <Button style={{ marginLeft: '10px', backgroundColor: '#1F419B' }} variant="primary" type="submit">
                Submit
            </Button>
        }
    }

    render() {
        return (
            <div>
                {(this.state.userExists ? <SiteMenu user={this.state.user} currentPage='serviceRequest' /> : <GuestSiteMenu currentPage='serviceRequest' />)}
                <Form onSubmit={this.handleSubmit} noValidate>
                    <Row className="form-row-first">
                        <Form.Label style={{ marginBottom: '0px' }} className="form-header">Rental Equipment Order Form</Form.Label>
                        <Form.Label style={{ fontSize: '15px', marginTop: '-5px', paddingTop: '0px', fontStyle: 'italic' }}>Provide request information below. A member of our team will process your request and call with any questions.</Form.Label>

                        <Form.Label className="form-header">Requestor Information</Form.Label>
                        <Col md={6}>
                            <Form.Group className="mb-3" controlId="accountNumber" hidden={!this.state.userExists}>
                                <Form.Label>Account Number</Form.Label>
                                <Form.Select name="accountNumber" onChange={this.handleFormChange}>
                                    {this.createSelectItems()}
                                </Form.Select>
                            </Form.Group>
                        </Col>
                    </Row>
                    <Row className="form-row-secondary">
                        <Col md>
                            <Form.Group className="mb-3" controlId="formFirstname">
                                <Form.Label>First name</Form.Label>
                                <Form.Control type="input" name="firstName" value={this.state.input.firstName} onChange={this.handleFormChange}
                                    isInvalid={!!this.state.errors.firstName} />
                            </Form.Group>
                        </Col>
                        <Col md>
                            <Form.Group className="mb-3" controlId="formLastname">
                                <Form.Label>Last name</Form.Label>
                                <Form.Control type="input" name="lastName" value={this.state.input.lastName} onChange={this.handleFormChange}
                                    isInvalid={!!this.state.errors.lastName} />
                            </Form.Group>
                        </Col>
                    </Row>
                    <Row className="form-row-secondary">
                        <Col md>
                            <Form.Group className="mb-3" controlId="formBasicEmail">
                                <Form.Label>Email address</Form.Label>
                                <Form.Control type="email" placeholder="Enter email" name="email" value={this.state.input.email} onChange={this.handleFormChange}
                                    isInvalid={!!this.state.errors.email} />
                                <Form.Control.Feedback type='invalid'>
                                    {this.state.errors.email}
                                </Form.Control.Feedback>
                            </Form.Group>
                        </Col>
                        <Col md>
                            <Form.Group className="mb-3" controlId="formPhoneNumber">
                                <Form.Label>Phone number</Form.Label>
                                <Form.Control type="phone" name="phoneNumber" value={this.state.input.phoneNumber} onChange={this.handleFormChange}
                                    isInvalid={!!this.state.errors.phoneNumber} />
                                <Form.Control.Feedback type='invalid'>
                                    {this.state.errors.phoneNumber}
                                </Form.Control.Feedback>
                            </Form.Group>
                        </Col>
                    </Row>

                    <Row className="form-row-first">
                        <Form.Label className="form-header">Rental Information</Form.Label>
                        <Col md={6} xs={12} >
                            <Form.Group className="mb-3" controlId="formProperyName">
                                <Form.Label>Property name</Form.Label>
                                <Form.Control type="input" name="propertyName" value={this.state.input.propertyName} onChange={this.handleFormChange}
                                    isInvalid={!!this.state.errors.propertyName} />
                            </Form.Group>
                        </Col>
                    </Row>
                    <Row className="form-row-secondary" >
                        <Col md>
                            <Form.Group className="mb-3" controlId="propertyAddress">
                                <Form.Label>Street address</Form.Label>
                                <Form.Control type="input" name="propertyAddress" value={this.state.input.propertyAddress} onChange={this.handleFormChange}
                                    isInvalid={!!this.state.errors.propertyAddress} />
                            </Form.Group>
                        </Col>
                        <Col md>
                            <Form.Group className="mb-3" controlId="propertyCity">
                                <Form.Label>City</Form.Label>
                                <Form.Control type="input" name="propertyCity" value={this.state.input.propertyCity} onChange={this.handleFormChange}
                                    isInvalid={!!this.state.errors.propertyCity} />
                            </Form.Group>
                        </Col>
                    </Row>
                    <Row className="form-row-secondary" >
                        <Col md>
                            <Form.Group className="mb-3" controlId="propertyState">
                                <Form.Label>State</Form.Label>
                                <Form.Select name="propertyState" value={this.state.input.propertyState} onChange={this.handleFormChange}>
                                    <option value="DC">DC</option>
                                    <option value="MD">MD</option>
                                    <option value="VA">VA</option>
                                    <option value="WV">WV</option>
                                </Form.Select>
                            </Form.Group>
                        </Col>
                        <Col md>
                            <Form.Group className="mb-3" controlId="propertyZip">
                                <Form.Label>Zip</Form.Label>
                                <Form.Control type="number" name="propertyZip" value={this.state.input.propertyZip} onChange={this.handleFormChange}
                                    isInvalid={!!this.state.errors.propertyZip} />
                            </Form.Group>
                        </Col>
                    </Row>
                    <Row className="form-row-secondary">
                        <Col md={6} xs={12}>
                            <Form.Group className="mb-3" controlId="rentalDate">
                                <Form.Label>Installation date</Form.Label>
                                <Form.Control type="date" min={moment().format('yyyy-MM-dd')} name="rentalDate" value={this.state.input.rentaldate} onChange={this.handleFormChange}
                                    isInvalid={!!this.state.errors.rentalDate} />
                            </Form.Group>
                        </Col>

                        <Form.Group className="mb-3" controlId="requestDetails">
                            <Form.Label>Request details</Form.Label>
                            <Form.Control as="textarea" rows={3} name="requestDetails" value={this.state.input.requestDetails} onChange={this.handleFormChange}
                                isInvalid={!!this.state.errors.requestDetails} />
                        </Form.Group>
                        <Form.Group controlId="formAttachment" className="mb-3">
                            <Form.Label>Attachments</Form.Label>
                            <Form.Control type="file" ref={this.fileControl} onChange={this.handleFileChange} multiple />
                        </Form.Group>
                    </Row>
                    {this.showButton()}
                </Form>
            </div>
        );
    }
}

export default RentalRequestForm;